import api from '../services/api';
import { IUser } from '../shared/interfaces';

interface IResponseGetUsers {
  data: IUser[];
  count: number;
}
export const getUsers = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetUsers> => {
  const response = await api.post('/users/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const getUser = async (id: string | undefined): Promise<IUser> => {
  if (!id) {
    throw new Error('ID do cliente não fornecido.');
  }
  const response = await api.get(`/users/${id}`);
  return response.data;
};

const normalizeUsers = (x: any): IUser[] => {
  if (!x) return [];
  if (Array.isArray(x)) return x;
  if (Array.isArray(x.data)) return x.data;
  if (Array.isArray(x.list)) return x.list;
  return [];
};

export const getSelectUsers = async (): Promise<IUser[]> => {
  const response = await api.get('/users/select');
  return normalizeUsers(response.data);
};

export const getSelectCrcAtendentes = async (): Promise<IUser[]> => {
  try {
    const response = await api.get('/users/select/crc-atendentes');
    const list = normalizeUsers(response.data);
    if (list.length > 0) return list;
    const fallback = normalizeUsers((await api.get('/users/select')).data);
    return fallback.map((u: IUser) => ({ ...u, is_crc_atendente: true }));
  } catch {
    try {
      const fallback = await api.get('/users/select');
      return normalizeUsers(fallback.data);
    } catch {
      return [];
    }
  }
};

export const postUser = async (payload: any): Promise<IUser> => {
  const response = await api.post(`/users`, payload);
  return response.data;
};

export const patchUser = async (
  id: string | undefined,
  payload: any,
): Promise<any> => {
  if (!id) {
    throw new Error('ID do usuário não fornecido.');
  }
  const response = await api.patch(`/users/${id}`, payload);
  return response.data;
};

export const patchUpdatePassword = async (
  id: string | undefined,
  payload: any,
) => {
  if (!id) {
    throw new Error('ID do usuário não fornecido.');
  }
  const response = await api.patch(`/users/update_password/${id}`, payload);
  return response.data;
};

export const patchResetPassword = async (user_reset_id: string | undefined) => {
  if (!user_reset_id) {
    throw new Error('ID do usuário não fornecido.');
  }

  const response = await api.patch(`/users/reset_password/${user_reset_id}`);
  return response.data;
};
